import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["checkbox", "selectAll", "select", "count"]
  static values = { resource: String }

  connect() {
    this.updateToolbar()
  }

  toggleAll(event) {
    const checked = event.target.checked
    this.checkboxTargets.forEach(checkbox => {
      checkbox.checked = checked
    })
    this.updateToolbar()
  }

  toggleRow() {
    this.updateToolbar()
    this.updateSelectAll()
  }

  updateToolbar() {
    const count = this.selectedIds.length

    if (this.hasSelectTarget) {
      this.selectTarget.disabled = count === 0
      this.countTarget.textContent = count === 0 ? "0 selected" : `${count} selected`
    }
  }

  updateSelectAll() {
    if (!this.hasSelectAllTarget) return
    const selectedCount = this.selectedIds.length

    const allChecked = this.checkboxTargets.length > 0 && 
                      this.checkboxTargets.length === selectedCount
    const someChecked = !allChecked && selectedCount > 0

    this.selectAllTarget.checked = allChecked
    this.selectAllTarget.indeterminate = someChecked
  }

  async execute(event) {
    const select = event.target
    const action = select.value
    
    // Reset select immediately
    const originalValue = action
    select.value = ""

    if (!action) return

    const ids = this.selectedIds
    if (ids.length === 0) return

    // Check for confirmation
    const option = select.querySelector(`option[value="${originalValue}"]`)
    if (option?.dataset.confirm) {
      if (!confirm(option.dataset.confirm)) return
    }

    try {
      const response = await fetch(`/${this.resourceValue}/bulk_${action}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-CSRF-Token": this.csrfToken,
          "Accept": "text/vnd.turbo-stream.html"
        },
        body: JSON.stringify({ ids })
      })

      const html = await response.text()
      if (response.ok) {
        Turbo.renderStreamMessage(html)
        this.clearSelection()
      } else {
        Turbo.renderStreamMessage(html)
        console.error("Bulk action failed:", response.statusText)
      }
    } catch (error) {
      console.error("Bulk action error:", error)
    }
  }

  clearSelection() {
    this.checkboxTargets.forEach(cb => cb.checked = false)
    if (this.hasSelectAllTarget) {
      this.selectAllTarget.checked = false
      this.selectAllTarget.indeterminate = false
    }
    this.updateToolbar()
  }

  get csrfToken() {
    return this._csrfToken ??= document.querySelector('meta[name="csrf-token"]')?.content
  }

  get selectedIds() {
    return this.checkboxTargets
      .filter(checkbox => checkbox.checked)
      .map(checkbox => checkbox.value)
  }
}
